import { render, staticRenderFns } from "./AddAliasForm.vue?vue&type=template&id=aed1e4d0&scoped=true"
import script from "./AddAliasForm.vue?vue&type=script&lang=ts"
export * from "./AddAliasForm.vue?vue&type=script&lang=ts"
import style0 from "./AddAliasForm.vue?vue&type=style&index=0&id=aed1e4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed1e4d0",
  null
  
)

export default component.exports